import React from "react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Linkedin, Instagram, MapPin, Phone, Mail } from "lucide-react";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-white/10 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <div key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-white transition-colors inline-block">
            {item.label}
          </Link>
        </div>)}
    </nav>;
}
export default function PiedDePage() {
  return <footer id="pied-de-page" className="text-primary-foreground border-t border-white/10 !bg-[hsl(192,91%,36%)] ![padding:20px_0px_0px_0px] !h-[280px]">
      <div className="container mx-auto px-6 !h-[210px]">
        <div className="grid grid-cols-1 md:grid-cols-4">
          {}
          <div className="flex flex-col gap-6 md:pr-8 md:border-r border-white/10 pb-8 md:pb-0">
            <Link to="/">
              <img src="https://nsdb.10web.cloud/wp-content/uploads/2026/03/nsb_logo_charcoal.png" alt="Nouvelle Société Du Bâtiment" className="h-7 w-auto object-contain opacity-90 transition-opacity !text-[hsl(0,0%,100%)] hover:opacity-100" />
            </Link>
            <p className="text-sm leading-relaxed !text-[hsl(0,0%,25%)]">
              Expertise depuis 2008.
              <br />
              Votre partenaire de confiance pour la construction et la rénovation en région Auvergne-Rhône-Alpes.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6 border-white/10 pb-8 pt-8 border-t border-white/10 !text-[hsl(0,0%,25%)] md:px-8 md:border-r md:pb-0 md:pt-0 md:border-t-0">
            <h3 className="font-semibold text-white tracking-tight">Liens rapides</h3>
            <MenuProvider menu_id="4" className="w-full">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6 md:px-8 md:border-r border-white/10 pb-8 md:pb-0 pt-8 md:pt-0 border-t md:border-t-0 border-white/10">
            <h3 className="font-semibold text-white tracking-tight">Siège social</h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 mt-1 shrink-0 text-primary" />
                <span className="!text-[hsl(0,0%,25%)]">20 Quai Pierre Scize, Lyon, Région Rhône Alpes</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="w-4 h-4 shrink-0 text-primary" />
                <Link to="tel:+33478000000" className="transition-colors !text-[hsl(0,0%,25%)] hover:text-white">+33 6 14 34 40 65</Link>
              </div>
              <div className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="w-4 h-4 shrink-0 text-primary" />
                <Link to="mailto:contact@new-societe-batiment.fr" className="transition-colors !text-[hsl(0,0%,25%)] hover:text-white">contact@nsdb.fr</Link>
              </div>
              <div className="mt-auto !p-0">
                <div className="flex gap-4 !items-start !justify-start">
                  <Link to="https://www.linkedin.com/in/nicolas-sicard-9b927722a?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BR5nHyU1mR9eIV3IkGdJ6Hg%3D%3D" newTab className="text-muted-foreground hover:text-accent transition-colors">
                    <Linkedin className="w-5 h-5" />
                    <span className="sr-only">LinkedIn</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6 md:pl-8 pt-8 md:pt-0 border-t md:border-t-0 border-white/10">
            <h3 className="font-semibold text-white tracking-tight">Informations légales</h3>
            <nav className="flex flex-col gap-3">
              <Link to="/mentions-legales" className="text-sm transition-colors !text-[hsl(0,0%,25%)] hover:text-white">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="text-sm transition-colors !text-[hsl(0,0%,25%)] hover:text-white">
                Politique de confidentialité
              </Link>
              
            </nav>
          </div>
        </div>

        <Separator className="my-12 bg-white/10" />

        <div className="flex flex-col justify-between items-center gap-4 text-xs text-muted-foreground !p-0 ![margin:-70px_0px_0px_0px] md:flex-row">
          <p>© {new Date().getFullYear()} Nouvelle Société Du Bâtiment. Tous droits réservés.</p>
          <p className="flex items-center gap-1">
            Conçu à Lyon
          </p>
        </div>
      </div>
    </footer>;
}